import { getColorValue } from '../lib/utils';

import type { IconProps } from '.';

export const Warning = ({ bgColor = 'illustration-face', fgColor = 'illustration-line', size = 64 }: IconProps) => {
  const bgHsl = getColorValue(bgColor);
  const fgHsl = getColorValue(fgColor);

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <path
        d="M2.15305 50.3921C1.66356 49.009 1.67214 47.4263 2.36761 45.9102L19.7671 7.97959C20.4162 6.56454 21.4996 5.56519 22.7531 5.00634C22.9242 4.88813 23.1053 4.78314 23.2967 4.69352C28.4458 2.28248 33.1954 5.05242 35.634 8.48914L62.161 45.9102C64.8338 49.6771 61.9548 56.0538 57.3561 56.4851L17.639 60.1988C14.2985 60.5121 6.62636 56.3809 3.41672 52.4877C2.89395 51.92 2.48054 51.2549 2.20433 50.5315C2.18627 50.4849 2.16917 50.4384 2.15305 50.3921Z"
        fill={fgHsl}
      />
      <path
        d="M26.8338 6.81464C27.4637 7.09036 28.0373 7.53876 28.4828 8.16657L52.6319 42.2003C52.8546 42.5142 53.0244 42.8435 53.1451 43.1801C53.9897 45.536 52.4257 48.246 49.7432 48.4975L8.19457 52.3944C6.48774 52.5545 5.04077 51.6525 4.31493 50.3384C3.73705 49.2922 3.61627 47.9847 4.18534 46.7441L21.5849 8.81353C22.5477 6.71445 24.9441 5.9875 26.8338 6.81464Z"
        fill={bgHsl}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.4188 37.469C29.4671 38.2246 28.9108 38.8598 28.1519 38.9155C27.3931 38.9712 26.6965 38.4279 26.5658 37.6783L23.2469 22.1491C22.3146 17.2747 23.2711 16.1533 25.7014 15.9657C28.1318 15.7781 29.4951 17.2379 29.5444 22.2112L29.4188 37.469Z"
        fill={fgHsl}
      />
      <path
        d="M31.1545 43.2693C31.284 44.7511 30.2745 45.8953 28.7927 46.0248C27.3109 46.1543 26.0264 45.154 25.8968 43.6722C25.7673 42.1904 26.7008 40.9189 28.1826 40.7894C29.6644 40.6598 31.0249 41.7875 31.1545 43.2693Z"
        fill={fgHsl}
      />
    </svg>
  );
};
